<template>
    <div class="faq">
        <default :items="items" :title="'FAQ'" :withAccordion="true"></default>
    </div>
</template>

<script>
import Default from '@views/public/layouts/Default'
import Faq from '@views/public/pages/Faq/faq'

export default {
    mixins: [Faq],
    components: {
        Default
    }
}
</script>

<style lang="scss">
.faq {

}
</style>
